import { render, staticRenderFns } from "./ReturnOverview.vue?vue&type=template&id=5cc5ea50&scoped=true"
import script from "./ReturnOverview.vue?vue&type=script&lang=js"
export * from "./ReturnOverview.vue?vue&type=script&lang=js"
import style0 from "./ReturnOverview.vue?vue&type=style&index=0&id=5cc5ea50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc5ea50",
  null
  
)

export default component.exports